import {
  AlreadyJoined,
  AlreadyVerified,
  EmailInviteMismatch,
  ExpiredInviteToken,
  ExpiredResetToken,
  ExpiredVerifyToken,
  UnknownAccount,
  UnknownError,
  deriveTitleFromErrorCode,
} from '@/pages/unauthenticated/auth/verify/error/components';
import { TokenTypeCode, TokenTypeCodeUnion } from '@/services/types';
import { ServiceErrorCode } from '@/services/utils/service-error';

interface VerifyErrorSectionProps {
  errorCode: ServiceErrorCode;
  type: TokenTypeCodeUnion;
  email: string;
}

export const VerifyErrorSection = ({
  type,
  email,
  errorCode,
}: VerifyErrorSectionProps) => {
  const heading = deriveTitleFromErrorCode(errorCode);

  switch (errorCode) {
    case ServiceErrorCode.AlreadyVerified: {
      return <AlreadyVerified heading={heading} />;
    }
    case ServiceErrorCode.AlreadyJoined: {
      return <AlreadyJoined heading={heading} />;
    }
    case ServiceErrorCode.InvalidToken: {
      if (type === TokenTypeCode.VER_ACC) {
        return <ExpiredVerifyToken email={email} heading={heading} />;
      } else if (type === TokenTypeCode.RES_PWD) {
        return <ExpiredResetToken heading={heading} />;
      } else if (type === TokenTypeCode.ORG_INV) {
        return <ExpiredInviteToken heading={heading} />;
      }
      return <UnknownError heading={heading} />;
    }
    case ServiceErrorCode.UnknownAccount: {
      return <UnknownAccount heading={heading} />;
    }
    case ServiceErrorCode.EmailInviteMismatch: {
      return <EmailInviteMismatch heading={heading} email={email} />;
    }
    default: {
      return <UnknownError heading={heading} />;
    }
  }
};
